export const LANGUAGE_CONTROLS = {
    language                  :   [, {updateOn: 'change' }],    
};